export const SUMMARY_VITALS_RETURNED = "SUMMARY_VITALS_RETURNED";
export const SUMMARY_VITALS_REQUESTED = "SUMMARY_VITALS_REQUESTED";